/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_TitleInputs */



/**
* | output |
* | --- |
* | "Marker Import" |
*
* @param {Marker_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_title = /** @type {((inputs?: Marker_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation des marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Marker-Import")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione marcatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт маркеров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de marcadores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标记导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーのインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर आयात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de Marcadores")
	return /** @type {LocalizedString} */ ("Marker Import")
});